import { render, staticRenderFns } from "./GraphUpIcon.vue?vue&type=template&id=104009ce&"
import script from "./GraphUpIcon.vue?vue&type=script&lang=ts&"
export * from "./GraphUpIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports